module.exports = __webpack_public_path__ + "yeni fransa mutfak 11.jpg?0f11259970f25673f4150b67ed0dcf85";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fransa mutfak 11.jpg
// module id = 376
// module chunks = 0